module.exports = [
    {
        "description": "From the Axciom Consumer database of more than 187 million households nationwide.",
        "targets": [
            {
                "idSearch": 82,
                "searchName": "Owner or Renter",
                "active": true,
                "datasource": "DEMOGRAPHICS CONSUMER",
                "allowToggleSiteAddress": false,
                "allowToggleCurrentResident": false,
                "idCompany": "188BETTERH",
                "idBranch": "",
                "description": "1. Renter or Owner List",
                "longDescription": "Create your targeted mailing list from the following options:\r\n\r\n\r\nChoose to Target Renters or Owners\r\n\r\n\r\nFrom 5 cents each for Single Use \r\nFrom 7 cents each for Multi Use\r\n",
                "tableHeader": "From the Axciom Consumer database of more than 187 million households nationwide.",
                "idPrimarySearch": 1426,
                "customizedInputs": true
            },
            {
                "idSearch": 60,
                "searchName": "Residence Value Only",
                "active": true,
                "datasource": "DEMOGRAPHICS CONSUMER",
                "allowToggleSiteAddress": false,
                "allowToggleCurrentResident": false,
                "idCompany": "188BETTERH",
                "idBranch": "",
                "description": "2. Estimated Residential Value Only Lists",
                "longDescription": "Create your targeted mailing list from the following options:\r\n\r\n\r\nEstimated Residential Value Only\r\n\r\n\r\nFrom 5.575 cents each for Single Use \r\nFrom 7.575 cents each  for Multi Use\r\n",
                "tableHeader": "From the Axciom Consumer database of more than 187 million households nationwide.",
                "idPrimarySearch": 1427,
                "customizedInputs": true
            },
            {
                "idSearch": 59,
                "searchName": "General Consumer Demographics",
                "active": true,
                "datasource": "DEMOGRAPHICS CONSUMER",
                "allowToggleSiteAddress": false,
                "allowToggleCurrentResident": false,
                "idCompany": "188BETTERH",
                "idBranch": "",
                "description": "3. Demographic Lists",
                "longDescription": "Create your targeted mailing list from the following options:\r\n\r\n\r\nEstimated Residential Value Only\r\n\r\n\r\nFrom 5.575 cents each for Single Use \r\nFrom 7.575 cents each  for Multi Use\r\n",
                "tableHeader": "From the Axciom Consumer database of more than 187 million households nationwide.",
                "idPrimarySearch": 1428,
                "customizedInputs": true
            },
            {
                "idSearch": 61,
                "searchName": "Res Value with Demographics",
                "active": true,
                "datasource": "DEMOGRAPHICS CONSUMER",
                "allowToggleSiteAddress": false,
                "allowToggleCurrentResident": false,
                "idCompany": "188BETTERH",
                "idBranch": "",
                "description": "4. Estimated Residential Value Lists with Demographics",
                "longDescription": "Create your targeted mailing list from the following options:\r\n\r\n\r\nNet worth \r\nGender \r\nEstimated Residence Value\r\n\r\nOwner or Renter\r\n\r\nLength of Residence\r\n\r\nIncome Range\r\n\r\nAge Range\r\n\r\n\r\nFrom 8.425 cents each for Single Use \r\nFrom 10.425 cents each  for Multi Use\r\n",
                "tableHeader": "From the Axciom Consumer database of more than 187 million households nationwide.",
                "idPrimarySearch": 1429,
                "customizedInputs": true
            }
        ]
    },
    {
        "description": "From the Dun & Bradstreet database of more than 33 million business records nationwide.",
        "targets": [
            {
                "idSearch": 103,
                "searchName": "SIC Codes ALL",
                "active": true,
                "datasource": "DEMOGRAPHICS BUSINESS",
                "allowToggleSiteAddress": false,
                "allowToggleCurrentResident": false,
                "idCompany": "188BETTERH",
                "idBranch": "",
                "description": "5. Search Business Data by SIC code",
                "longDescription": "Create your targeted mailing list from the following options: \r\n\r\n\r\nSIC Code\r\nNumber of Employees\r\n\r\n\r\n\r\nFrom 12.75 cents each for Single Use\r\nFrom 13.75 cents each for Multi Use\r\n",
                "tableHeader": "From the Dun & Bradstreet database of more than 33 million business records nationwide.",
                "idPrimarySearch": 1430,
                "customizedInputs": true
            }
        ]
    }
]